<!-- ABOUTME: Filter panel component for broadcast email form -->
<!-- ABOUTME: Emits filter changes to parent without page reload -->
<template>
  <div class="bg-white rounded-lg border border-gray-200 p-4 shadow-sm">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-sm font-semibold text-gray-900">Filters</h3>
      <button
        v-if="hasActiveFilters"
        @click="clearFilters"
        type="button"
        class="text-xs text-primary hover:text-primary-dark cursor-pointer">
        Clear All
      </button>
    </div>

    <div class="space-y-3">
      <select
        v-model="localFilters.language"
        class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-primary"
        :class="{ 'active-filter': localFilters.language }">
        <option value="">All Languages</option>
        <option value="sk">Slovak</option>
        <option value="en">English</option>
        <option value="cs">Czech</option>
        <option value="hu">Hungarian</option>
        <option value="not_set">Not Set</option>
      </select>

      <select
        v-model="localFilters.subscription_tier"
        class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-primary"
        :class="{ 'active-filter': localFilters.subscription_tier }">
        <option value="">All Tiers</option>
        <option value="free">Free</option>
        <option value="standard">Standard</option>
        <option value="pilot">Pilot</option>
      </select>

      <select
        v-model="localFilters.has_projects"
        class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-primary"
        :class="{ 'active-filter': localFilters.has_projects }">
        <option value="">All Users</option>
        <option value="true">With Projects</option>
        <option value="false">Without Projects</option>
      </select>

      <select
        v-model="localFilters.has_connections"
        class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-primary"
        :class="{ 'active-filter': localFilters.has_connections }">
        <option value="">All Users</option>
        <option value="true">With Connections</option>
        <option value="false">Without Connections</option>
      </select>
    </div>

    <button
      @click="emitFilters"
      type="button"
      class="mt-4 w-full px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary-dark focus:outline-none focus:ring-primary transition-colors cursor-pointer">
      Apply Filters
    </button>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  currentFilters: {
    type: Object,
    default: () => ({
      language: '',
      subscription_tier: '',
      has_projects: '',
      has_connections: ''
    })
  }
})

const emit = defineEmits(['filters-changed'])

const localFilters = ref({ ...props.currentFilters })

// Watch for external changes
watch(() => props.currentFilters, (newFilters) => {
  localFilters.value = { ...newFilters }
}, { deep: true })

const hasActiveFilters = computed(() => {
  return Object.values(localFilters.value).some(v => v !== '')
})

function emitFilters() {
  emit('filters-changed', { ...localFilters.value })
}

function clearFilters() {
  localFilters.value = {
    language: '',
    subscription_tier: '',
    has_projects: '',
    has_connections: ''
  }
  emitFilters()
}
</script>

<style scoped>
.active-filter {
  border-color: #3b82f6;
  background-color: #eff6ff;
}
</style>
